/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as Msdyn365 from '@msdyn365-commerce/core';
import { OnlineChannel } from '@msdyn365-commerce/retail-proxy';
import { getOnlineChannelAsync } from '@msdyn365-commerce/retail-proxy/dist/DataActions/StoreOperationsDataActions.g';

export class GetOnlineChannelInput implements Msdyn365.IActionInput {
    public channelId: number;

    constructor(channelId: number) {
        this.channelId = channelId;
    }

    public getCacheKey = () => `GetOnlineChannel-${this.channelId}`;
    public getCacheObjectType = () => 'OnlineChannel';
    public dataCacheType = (): Msdyn365.CacheType => 'application';
}

const createInput = (args: Msdyn365.ICreateActionContext): Msdyn365.IActionInput => {
    return new GetOnlineChannelInput(args.requestContext.apiSettings.channelId);
};

async function action(input: GetOnlineChannelInput, ctx: Msdyn365.IActionContext): Promise<OnlineChannel> {
    const onlineChannel = await getOnlineChannelAsync({ callerContext: ctx }, input.channelId);
    return onlineChannel;
}

export default Msdyn365.createObservableDataAction({
    action: <Msdyn365.IAction<OnlineChannel>>action,
    id: 'DEFA/GetOnlineChannel',
    input: createInput
});
